module.exports = __webpack_public_path__ + "2ecb365c90a13dc3516dd1333798ff23.ttf";